import React from 'react'
import { Dropdown, Menu } from 'antd'
import sharedUserSVG from 'assets/images/calendar/accessory-shared-calendar.svg'
import sharedOwnerSVG from 'assets/images/calendar/accessory-shared-owner.svg'
import chevronDownIcon from 'assets/images/chevron-down-24.svg'
import moreVerticalSVG from 'assets/images/more-vert-24.svg'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'

interface FolderListItemProps {
  folderId: string
  displayName: string
  isShared?: boolean
  isSharedOwner?: boolean
  isChecked?: boolean
  isDefault?: boolean
  isOrgShared?: boolean
  color?: string
  onCheckClick: (checked: boolean, folderId: string) => void
  onFolderEdit?: (folderId: string) => void
  onShareClick?: (folderId: string) => void
  onDeleteClick?: (folderId: string) => void
  onUnsubscribeClick?: (folderId: string) => void
  onClick?: (() => void) | null
  height?: string | number | null
  disabledHover?: boolean
  isTodoFolder?: boolean
  isCalendarFolder?: boolean
  isSubscription?: boolean
}

const FolderListItem: React.FC<FolderListItemProps> = ({
  folderId,
  displayName,
  isShared = false,
  isSharedOwner = false,
  isChecked = false,
  isDefault = false,
  isOrgShared = false,
  color = '#0078FF',
  onCheckClick,
  onFolderEdit,
  onShareClick,
  onDeleteClick,
  onUnsubscribeClick,
  onClick = null,
  height = null,
  disabledHover = false,
  isTodoFolder = false,
  isCalendarFolder = true,
  isSubscription = false,
}) => {
  const { t } = useTranslation()
  const editMenuItems: any[] = []

  if (isSubscription) {
    editMenuItems.push({
      key: 'edit',
      label: t('common.button.edit'),
      onClick: () => {
        onFolderEdit?.(folderId)
      },
    })
    editMenuItems.push({
      key: 'separator',
      type: 'divider',
    })
    editMenuItems.push({
      key: 'unsubscribe',
      label: t('calendar.subscription.unsubscribe'),
      onClick: () => {
        onUnsubscribeClick?.(folderId)
      },
      style: {
        color: 'red',
      },
    })
  } else {
    editMenuItems.push({
      key: 'edit',
      label: t('common.button.edit'),
      onClick: () => {
        onFolderEdit?.(folderId)
      },
    })

    if (isCalendarFolder) {
      if (isShared) {
        editMenuItems.push({
          key: 'share',
          label: t('calendar.share.buttonShared'),
          onClick: () => {
            onShareClick?.(folderId)
          },
        })
      } else {
        editMenuItems.push({
          key: 'share',
          label: t('calendar.share.button'),
          onClick: () => {
            onShareClick?.(folderId)
          },
        })
      }
    }

    if (isTodoFolder) {
      if (isShared) {
        editMenuItems.push({
          key: 'share',
          label: t('todo.share.buttonShared'),
          onClick: () => {
            onShareClick?.(folderId)
          },
        })
      } else {
        editMenuItems.push({
          key: 'share',
          label: t('todo.share.button'),
          onClick: () => {
            onShareClick?.(folderId)
          },
        })
      }
    }

    if (!isDefault && !isOrgShared) {
      editMenuItems.push({
        key: 'separator',
        type: 'divider',
      })

      editMenuItems.push({
        key: 'delete',
        label: t('common.button.delete'),
        onClick: () => {
          onDeleteClick?.(folderId)
        },
        style: {
          color: 'red',
        },
      })
    }
  }

  const editMenu = <Menu items={editMenuItems} className={classNames(styles.contextMenu)} />

  return (
    <div
      className={classNames(styles.container, { [styles.disabledHover]: disabledHover })}
      onClick={onClick || undefined}
      style={{ height: height || undefined }}
    >
      <button
        className={`${styles.checkButton} ${isChecked ? styles.checked : ''}`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onCheckClick(!isChecked, folderId)
        }}
        style={{ '--color': color } as React.CSSProperties}
      >
        {isChecked && (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M11.6667 3.5L5.25 9.91667L2.33333 7"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>
      <span className={styles.displayName}>{displayName}</span>
      {isShared && <img src={sharedUserSVG} alt="shared" className={styles.sharedIcon} />}
      {isSharedOwner && <img src={sharedOwnerSVG} alt="shared" className={styles.sharedIcon} />}
      {(onFolderEdit || onShareClick) && (
        <Dropdown
          {...({} as any)}
          popupRender={() => editMenu}
          trigger={['click']}
          placement="bottomRight"
          overlayClassName={'contextMenu'}
          icon={<img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />}
        >
          <button className={styles.moreButton} onClick={(e) => e.preventDefault()}>
            <img src={moreVerticalSVG} alt="more" />
          </button>
        </Dropdown>
      )}
    </div>
  )
}

export default FolderListItem
